var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sonar-loader__wrapper"},[_c('ActionLoader',_vm._b({},'ActionLoader',{ name: _vm.name, color: _vm.color, size: _vm.size },false)),_c('div',{staticClass:"sonar-loader__label"},[_vm._v(_vm._s(_vm.label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }